module.exports = "/static/assets/99d02fcf3c99628bd845723907dd4184.png";